module.exports = __webpack_public_path__ + "static/img/wavm8s-012-cralias.ec40d90.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wav/wavm8s-012-cralias.png
// module id = tjQV
// module chunks = 0